import { useDebounceTextChange } from "~/client/components/search/hooks/useDebounceTextChange";
import { useGetSearchMemberResultLazyQuery } from "~/client/generated/schema";
import type { ConnectionWithTotalCount } from "~/client/utils/relay";
import { emptyConnection } from "~/client/utils/relay";

export interface MemberItem {
  account: string;
  realName: string;
  avatar1x: { url: string };
  avatar2x: { url: string };
}

export const useMemberSearchResult = (query: string, debounceTime: number = 500) => {
  const [search, { data, loading }] = useGetSearchMemberResultLazyQuery();

  const [changing] = useDebounceTextChange(
    (query) => {
      search({ variables: { query } });
    },
    query,
    debounceTime,
  );

  return {
    items: (data?.users as ConnectionWithTotalCount<MemberItem>) || emptyConnection<MemberItem>(),
    isLoading: loading || changing,
  };
};
